// Module
var code = "<script>let $ctrl</script> <div class=\"flexWrapper__headerPanel\"> <organism-page-header-panel page-header-data=\"$ctrl.pageHeaderData\"></organism-page-header-panel> </div> <organism-dns-wizard-wrapper product-code=\"$ctrl.productCode\" product-family=\"$ctrl.productFamily\"></organism-dns-wizard-wrapper> ";
// Exports
module.exports = code;